export const SLACK_INTEGRATION_ID_STORAGE_KEY = "_mpq_slack_integration_id";
